// Mock data for DGradnja construction company website

export const services = [
  {
    id: 1,
    title: "Fasadni Radovi",
    description: "Profesionalna izvedba svih vrsta fasadnih radova - od termoizolacije do dekorativnih završnih obrada. Vaša fasada u pouzdanim rukama.",
    image: "https://images.pexels.com/photos/30661413/pexels-photo-30661413.jpeg",
    features: ["Vanjska obloga", "Termoizolacija", "Dekorativne fasade", "Završne obrade"],
    gallery: [
      "https://customer-assets.emergentagent.com/job_craft-build-group/artifacts/3p7qztdp_WhatsApp%20Slika%202025-11-24%20u%2010.03.56_77a5ac69.jpg",
      "https://customer-assets.emergentagent.com/job_craft-build-group/artifacts/vh4z97ls_WhatsApp%20Slika%202025-11-30%20u%2014.44.44_e6795008.jpg",
      "https://customer-assets.emergentagent.com/job_craft-build-group/artifacts/iptp7dqk_WhatsApp%20Slika%202025-11-30%20u%2014.44.44_ebf9aaa6.jpg",
      "https://customer-assets.emergentagent.com/job_craft-build-group/artifacts/wkc1mx9g_WhatsApp%20Slika%202025-11-30%20u%2014.44.44_3b0fc250.jpg",
      "https://customer-assets.emergentagent.com/job_craft-build-group/artifacts/s4x724hh_WhatsApp%20Slika%202025-11-30%20u%2014.44.44_48a78f4c.jpg"
    ]
  },
  {
    id: 2,
    title: "Suha Gradnja",
    description: "Moderna suha gradnja uključujući pregradne zidove, spuštene plafone i gipsane konstrukcije. Brzo, čisto i učinkovito.",
    image: "https://images.unsplash.com/photo-1615856210162-9ae33390b1a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjBzZXJ2aWNlc3xlbnwwfHx8fDE3NjM4MjE0MTh8MA&ixlib=rb-4.1.0&q=85",
    features: ["Pregradni zidovi", "Spušteni plafoni", "Gips karton", "Zvučna izolacija"]
  },
  {
    id: 3,
    title: "Soboslikarski Radovi",
    description: "Stručno bojanje i dekoriranje interijera i eksterijera. Preciznost i kvaliteta u svakom potezu kista.",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzZXJ2aWNlc3xlbnwwfHx8fDE3NjM4MjE0MTh8MA&ixlib=rb-4.1.0&q=85",
    features: ["Bojanje zidova", "Dekorativne tehnike", "Lakiranje", "Gletanje"]
  },
  {
    id: 4,
    title: "Adaptacije Ključ u Ruke",
    description: "Kompletna adaptacija vašeg prostora od ideje do realizacije. Mi se brinemo o svemu, vi uživate u rezultatu.",
    image: "https://images.unsplash.com/photo-1759269106004-ae48d47d4955?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzYzODIxNDEzfDA&ixlib=rb-4.1.0&q=85",
    features: ["Projektiranje", "Svi građevinski radovi", "Nadzor", "Završne obrade"]
  },
  {
    id: 5,
    title: "Keramičarski Radovi",
    description: "Profesionalna ugradnja keramičkih pločica za zidove i podove. Preciznost i estetika u svakom detalju.",
    image: "https://images.unsplash.com/photo-1738817628138-b794ed944ed5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzZXJ2aWNlc3xlbnwwfHx8fDE3NjM4MjE0MTh8MA&ixlib=rb-4.1.0&q=85",
    features: ["Keramičke pločice", "Mozaik", "Kupaone", "Kuhinje"]
  },
  {
    id: 6,
    title: "Postave Laminata",
    description: "Stručna ugradnja laminatnih podova svih vrsta. Brza postava, dugotrajna ljepota.",
    image: "https://images.pexels.com/photos/7464233/pexels-photo-7464233.jpeg",
    features: ["Laminatni podovi", "Podloge", "Lajsne", "Priprema podloge"]
  },
  {
    id: 7,
    title: "Postava Kocki i Betonaža",
    description: "Profesionalna betonaža i postava betonskih kocki za dvorišta, parkirališta i prilaze.",
    image: "https://images.pexels.com/photos/34831719/pexels-photo-34831719.jpeg",
    features: ["Betonske kocke", "Dvorišne kocke", "Betonaža", "Pripremni radovi"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Obiteljska Kuća Zagreb",
    category: "Stambeno",
    description: "Kompletna adaptacija obiteljske kuće u Zagrebu. Uključuje sve faze radova - od suhe gradnje, soboslikarskih radova do završnih obrada.",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBmaW5pc2hlZCUyMGhvdXNlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzM1OTA4MDc3fDA&ixlib=rb-4.1.0&q=85",
    year: "2024",
    area: "180m²"
  },
  {
    id: 2,
    title: "Stambena Zgrada Zagreb",
    category: "Stambeno",
    description: "Kompletni radovi na stambenoj zgradi uključujući fasadne radove, suhu gradnju i završne obrade interijera.",
    image: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcGFydG1lbnQlMjBidWlsZGluZ3xlbnwwfHx8fDE3Njc2OTg5NzB8MA&ixlib=rb-4.1.0&q=85",
    year: "2024",
    area: "850m²"
  },
  {
    id: 3,
    title: "Keramički Radovi Samobor",
    category: "Stambeno",
    description: "Profesionalna ugradnja keramike u kupaonicama i kuhinji. Precizna izvedba s vrhunskim materijalima.",
    image: "https://images.pexels.com/photos/35505514/pexels-photo-35505514.jpeg",
    year: "2024",
    area: "120m²"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marko Horvat",
    role: "Vlasnik, Villa Adriatica",
    content: "Dekor Art gradnja je izgradila našu vilu s nevjerojatnom preciznošću i profesionalnošću. Kvaliteta radova i poštivanje rokova bili su izvanredni. Toplo preporučujem!",
    rating: 5
  },
  {
    id: 2,
    name: "Ana Kovačević",
    role: "Direktorica, TechHub d.o.o.",
    content: "Za naš poslovni prostor trebali smo pouzdanog partnera. Dekor Art gradnja je premašila sva očekivanja - od projektiranja do završne izvedbe. Iznimno zadovoljni!",
    rating: 5
  },
  {
    id: 3,
    name: "Petar Novak",
    role: "Privatni investitor",
    content: "Renovacija stana nikad nije bila lakša. Tim Dekor Art gradnje je bio profesionalan, uredan i precizan. Rezultat je nadmašio naša očekivanja. Definitivno ću ih ponovno angažirati.",
    rating: 5
  }
];

export const stats = [
  {
    id: 1,
    value: "2024",
    label: "Godina Osnivanja"
  },
  {
    id: 2,
    value: "50+",
    label: "Završenih Projekata"
  },
  {
    id: 3,
    value: "100%",
    label: "Zadovoljni Klijenti"
  },
  {
    id: 4,
    value: "20+",
    label: "Stručnjaka u Timu"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Vrhunska Kvaliteta",
    description: "Koristimo samo najbolje materijale i najnovije tehnologije u građevinarstvu."
  },
  {
    id: 2,
    title: "Pouzdanost",
    description: "Poštujemo rokove i obveze prema klijentima. Vaš projekt je naš prioritet."
  },
  {
    id: 3,
    title: "Iskustvo",
    description: "Tim s bogatim iskustvom uspješno realizira projekte različitih veličina i složenosti."
  },
  {
    id: 4,
    title: "Sigurnost",
    description: "Svi naši radovi izvode se prema najvišim sigurnosnim standardima."
  },
  {
    id: 5,
    title: "Održivost",
    description: "Fokusirani smo na ekološki održive i energetski učinkovite građevinske metode."
  },
  {
    id: 6,
    title: "Korisnička Podrška",
    description: "Dostupni smo 24/7 za sve vaše potrebe i upite tijekom cijelog projekta."
  }
];